import { Button } from '@antimatterhq/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@antimatterhq/ui/components/dialog';

interface UnsavedChangedDialogProps {
  title?: string;
  description?: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onDiscard: () => void;
  isConfirming?: boolean;
  saveLabel?: string;
  discardLabel?: string;
  cancelLabel?: string;
}

export const UnsavedChangesDialog = ({
  title = 'You have unsaved changes',
  description,
  open,
  onConfirm,
  onCancel,
  onDiscard,
  isConfirming,
  saveLabel = 'Save',
  discardLabel = 'Discard',
  cancelLabel = 'Cancel',
}: UnsavedChangedDialogProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => !isOpen && onCancel()}
      data-testid="unsaved-changes-dialog"
    >
      <DialogContent data-testid="unsaved-changes-dialog-content">
        <DialogHeader data-testid="unsaved-changes-dialog-header">
          <DialogTitle data-testid="unsaved-changes-dialog-title">
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription data-testid="unsaved-changes-dialog-description">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter data-testid="unsaved-changes-dialog-footer">
          <DialogClose asChild>
            <Button
              variant="default"
              disabled={isConfirming}
              data-testid="unsaved-changes-dialog-cancel-button"
            >
              {cancelLabel}
            </Button>
          </DialogClose>
          <Button
            onClick={onDiscard}
            variant="danger"
            disabled={isConfirming}
            data-testid="unsaved-changes-dialog-discard-button"
          >
            {discardLabel}
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            disabled={isConfirming}
            loading={isConfirming}
            data-testid="unsaved-changes-dialog-save-button"
          >
            {saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
